import React, { useEffect, useState } from "react";
import "./Gridmodule.css";

const GridLayout = ({
  paginatedData,
  numPostsToShow,
  showImgToggler,
  showPostTitle,
  showMeta,
  showContent,
  contentType,
  truncateContent,
  wordsLimit,
  imageUrl,
  valueForWidth,
  widthPercentage,
  widthController,
  ImgWidth,
  height,
  columnGap,
  rowGap,
  totalColoms,
  ReadMoreBgColor,
  showReadMoreToggler,
  ReadMoreTextColor,
  button_Top_bottom_Padding,
  button_Right_Left_Padding,
  title_font_size,
  Meta_font_size,
  Content_font_size,
  Read_more_font_size,
  __,
  customCSS,
  title_Manage_styling,
  Content_Manage_styling,
  ReadMoreText,
  Meta_Manage_styling,
}) => {
  const GridItems = paginatedData.slice(0, numPostsToShow);

  const getGridTemplateColumns = (totalColoms) => {
    const width = window.innerWidth;
    if (width >= 992 && width < 1200) {
      return `repeat(${totalColoms || 1}, 1fr)`;
    } else if (width >= 1200) {
      return `repeat(${totalColoms || 1}, 1fr)`;
    }
  };
  const [gridColumns, setGridColumns] = useState(getGridTemplateColumns());
  useEffect(() => {
    const handleResize = () => {
      setGridColumns(getGridTemplateColumns(totalColoms));
    };
    window.addEventListener("resize", handleResize);
    setGridColumns(getGridTemplateColumns(totalColoms));
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [totalColoms]);
  return (
    <div className="wep-root">
      <div
        className="grid-layout"
        style={{
          columnGap: columnGap || "30px",
          rowGap: rowGap || "30px",
          gridTemplateColumns: gridColumns,
        }}
      >
        {customCSS && <style>{customCSS}</style>}
        {GridItems.map((item) => {
          const formattedDate = new Date(item?.date).toLocaleDateString(
            "en-US",
            {
              year: "numeric",
              month: "long",
              day: "numeric",
            }
          );

          let featuredImgExist = false;
          if (item.hasOwnProperty("featured_image_url")) {
            const featuredImageUrlObj = item.featured_image_url;
            if (
              featuredImageUrlObj &&
              typeof featuredImageUrlObj === "object" &&
              Object.keys(featuredImageUrlObj).length > 0
            ) {
              featuredImgExist = true;
            }
          }

          return (
            <div
              key={item.id}
              className="wep-card">
         {showImgToggler &&
                item?.featured_image_url &&
                featuredImgExist && (
                  <div className="wep-card-img">
                    <img
                      src={item.featured_image_url[imageUrl]}
                     
                    />
                    {item.assigned_categories && (
                      <span className="wep-chip">
                        {item.assigned_categories}
                      </span>
                    )}
                  </div>
                )}

              <div className="wep-card-body">
                <div className="wep-card-heading">
                  {showPostTitle && (
                    <h4
                      className="wep-card-title"
                      style={{
                        ...(title_Manage_styling && {
                          fontSize: title_font_size,
                        }),
                      }}
                    >
                      <a
                        href={item.link}
                        dangerouslySetInnerHTML={{
                          __html: item?.title.rendered,
                        }}
                      ></a>
                    </h4>
                  )}

                  {showMeta && (
                    <div
                      className="meta-data"
                      style={{
                        ...(Meta_Manage_styling && {
                          fontSize: Meta_font_size,
                        }),
                      }}
                    >
                      {formattedDate && `${formattedDate} `}
                      {item.post_author && `| Author: ${item.post_author}`}
                    </div>
                  )}
                </div>
                {showContent && (
                  <div
                    style={{
                      ...(Content_Manage_styling && {
                        fontSize: Content_font_size,
                      }),
                    }}
                    className="wep-card-text"
                    dangerouslySetInnerHTML={{
                      __html:
                        contentType === "Full-Post"
                          ? item?.content?.rendered
                          : !item?.excerpt?.rendered
                          ? truncateContent(item?.content?.rendered, wordsLimit)
                          : truncateContent(
                              item?.excerpt?.rendered,
                              wordsLimit
                            ),
                    }}
                  />
                )}
              </div>
              <div className="wep-card-footer">
                <a
                  href={item.link}
                  target="_blank"
                  className="wep-btn wep-btn-primary"
                  style={{
                    ...(showReadMoreToggler && {
                      "--wep-btn-bg": ReadMoreBgColor,
                      "--wep-btn-hover-bg": `color-mix(in srgb, ${ReadMoreBgColor}, black 20%)`,
                      "--wep-btn-color": ReadMoreTextColor,
                      "--wep-btn-hover-color": ReadMoreTextColor,
                      "--wep-btn-padding-y": button_Top_bottom_Padding,
                      "--wep-btn-padding-x": button_Right_Left_Padding,
                      "--wep-btn-font-size": Read_more_font_size,
                    }),
                  }}
                >
                 {__(ReadMoreText || 'Read More', "advanced-posts-listing")}
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GridLayout;
